import * as React from "react";

import { cn } from "~/lib/utils";

function Textarea({
  className,
  variant,
  ...props
}: React.ComponentProps<"textarea"> & { variant?: "outline" | "normal" }) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        variant === "outline" ? "border-black border-2" : "",
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
